import { debounce } from 'lodash';
import { useCallback, useEffect } from 'react';

const updateViewheight = (): void => {
  document?.documentElement.style.setProperty('--view-height', `${window.innerHeight}px`);
};

/**
 * Sets CSS variable --view-height to the browser view height, fixes overlapping mobile browser navigation.
 * Android does removes size from keyboard as well, iOS does not
 */
export const useCssViewHeight = (): void => {
  const debouncedUpdateViewHeight = useCallback(debounce(updateViewheight, 100), []);

  useEffect((): (() => void) | void => {
    if (typeof window === 'undefined') return;

    updateViewheight();

    window.addEventListener('resize', debouncedUpdateViewHeight);

    return (): void => window.removeEventListener('resize', debouncedUpdateViewHeight);
  }, []);
};
